'use strict'

import BazingaTranslator from 'bazinga-translator'
window.BazingaTranslator = BazingaTranslator;

export default class VueTranslator {
  static install (Vue, options) {
    Vue.prototype.$t = (key, options = {}) => {
      return BazingaTranslator.trans(key, options)
    }
    Vue.prototype.$transChoice = (key, count, options = {}) => {
      return BazingaTranslator.transChoice(key, count, options)
    }
  }
}
